export default "__VITE_ASSET__CMEMTIOz__"